import {
    ActionTypes,
    PaidNewslettersTermsLoadAction,
    PaidNewslettersTermsLoadErrorAction,
    PaidNewslettersTermsLoadSuccessAction,
    PaidNewslettersTermsState,
    PaidNewslettersTermsUpdateAction,
    PaidNewslettersTermsUpdateErrorAction,
    PaidNewslettersTermsUpdateSuccessAction,
    PaidNewslettersTermsModifyErrorAction,
    PaidNewslettersTermsModifySuccessAction,
    PaidNewslettersTermsPayload
} from './types';
import { ApplicationState } from '..';


export const PaidNewslettersTermsLoadStart = (): PaidNewslettersTermsLoadAction => ({
    type: ActionTypes.LOAD_START
});
export const PaidNewslettersTermsLoadSuccess = (payload: PaidNewslettersTermsPayload): PaidNewslettersTermsLoadSuccessAction => ({
    type: ActionTypes.LOAD_SUCCESS,
    payload,
});
export const PaidNewslettersTermsLoadError = (): PaidNewslettersTermsLoadErrorAction => ({
    type: ActionTypes.LOAD_ERROR,
});


export const PaidNewslettersTermsUpdate = (payload: PaidNewslettersTermsPayload): PaidNewslettersTermsUpdateAction => ({
    type: ActionTypes.UPDATE_START,
    payload,
});
export const PaidNewslettersTermsUpdateSuccess = (payload: PaidNewslettersTermsPayload): PaidNewslettersTermsUpdateSuccessAction => ({
    type: ActionTypes.UPDATE_SUCCESS,
    payload,
});
export const PaidNewslettersTermsUpdateError = (): PaidNewslettersTermsUpdateErrorAction => ({
    type: ActionTypes.UPDATE_ERROR,
});

export const PaidNewslettersTermsModifySuccess = (payload: PaidNewslettersTermsPayload): PaidNewslettersTermsModifySuccessAction => ({
    type: ActionTypes.MODIFY_SUCCESS,
    payload,
});
export const PaidNewslettersTermsModifyError = (): PaidNewslettersTermsModifyErrorAction => ({
    type: ActionTypes.MODIFY_ERROR,
});


export const getPaidNewslettersTermsStore = (store: ApplicationState): PaidNewslettersTermsState => store.paidNewslettersTerms || {} as PaidNewslettersTermsState;